import { useState, useRef } from 'react';
import { Popover, withTheme } from '@material-ui/core';
import { format, subDays, isSameDay } from 'date-fns';
import FieldError from './FieldError';
import DateRangePicker from '../../../../Reports/DriverPerformance/components/DateRangePicker';
import DateRangeInputBox from './DateRangeInputBox';
import constants from '../constants';

const CustomDateRangePicker = ({
  selectedDateRange,
  onChangeDateRange,
  theme,
  labelText='',
  errorInfo={},
  staticRanges,
  maxDate,
  minDate = null,
  fullWidth=false,
  skipMaxDate=false,
  shouldDisplayDateRange=true,
}) => {
  const anchorRef = useRef(null);
  const [openCalendar, setOpenCalendar] = useState(false);

  const onDateRangeChange = (ranges) => {
    const { selection } = ranges;
    onChangeDateRange([selection]);
  };

  const closeDateRangePicker = () => {
    setOpenCalendar(false);
    anchorRef.current = null;
  };

  const onOpenCalendar = (event) => {
    anchorRef.current = event.currentTarget;
    setOpenCalendar(true);
  };

  const defaultMaxDate = maxDate || subDays(new Date(), 1);

  return (
    <>
      <DateRangeInputBox
        startDate={
          shouldDisplayDateRange && selectedDateRange[0]?.startDate
            ? format(selectedDateRange[0].startDate, constants.DISPLAY_DATE_FORMAT)
            : constants.DISPLAY_DATE_FORMAT
        }
        endDate={
          shouldDisplayDateRange && selectedDateRange[0]?.endDate
            ? format(selectedDateRange[0].endDate, constants.DISPLAY_DATE_FORMAT)
            : constants.DISPLAY_DATE_FORMAT
        }
        onClick={onOpenCalendar}
        labelText={labelText}
        fullWidth={fullWidth}
      />
      {openCalendar && (
        <Popover
          open={open}
          anchorEl={anchorRef.current}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center'
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center'
          }}>
          <DateRangePicker
            rangeColors={[theme.palette.primary.main]}
            onChange={onDateRangeChange}
            showSelectionPreview
            moveRangeOnFirstSelection={false}
            retainEndDateOnFirstSelection={false}
            months={1}
            startDatePlaceholder="From"
            endDatePlaceholder="To"
            {...(skipMaxDate ? {} : { maxDate: defaultMaxDate })}
            ranges={selectedDateRange}
            inputRanges={[]}
            dateDisplayFormat={constants.DISPLAY_DATE_FORMAT}
            direction="vertical"
            editableDateInputs
            color= {theme.palette.primary.main}
            handleClose={closeDateRangePicker}
            {...(minDate ? { minDate } : {})}
            staticRanges={staticRanges.map(({ label, value }) => ({
              label,
              range: () => ({
                startDate: subDays(new Date(), maxDate ? value-1: value),
                endDate: defaultMaxDate
              }),
              isSelected(range) {
                const definedRange = this.range();
                return (
                  isSameDay(range.startDate, definedRange.startDate) &&
                  isSameDay(range.endDate, definedRange.endDate)
                );
              }
            }))}
          />
        </Popover>
      )}
      {errorInfo.selectedDateRange && <FieldError error={errorInfo.selectedDateRange} />}
    </>
  );
};

export default withTheme()(CustomDateRangePicker);
